/* eslint-disable */

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    AgendaEvent: [
      "EarningsResultsEvent",
      "LabeledEvent",
      "PaymentOfDividendsEvent",
      "PaymentOfStockDividendsEvent",
      "RightsIssueEvent",
      "SpinOffEvent",
      "StandardEvent",
      "StockSplitEvent",
    ],
    AnswerablePost: ["PostReply"],
    Asset: ["AmericanCompanyIssuer", "BrazilianCompanyIssuer", "BrazilianRealEstateFund"],
    BrazilianBankFinancialStatementRow: [
      "QuarterlyBrazilianBankFinancialStatementRow",
      "YearlyBrazilianBankFinancialStatementRow",
    ],
    BrazilianCompanyFinancialStatementRow: [
      "QuarterlyBrazilianCompanyFinancialStatementRow",
      "YearlyBrazilianCompanyFinancialStatementRow",
    ],
    BrazilianCompanyIssuerSharesTotal: [
      "BrazilianCompanyIssuerFreeFloat",
      "BrazilianCompanyIssuerShareholderPosition",
      "BrazilianCompanyIssuerSharesOutstanding",
      "BrazilianCompanyIssuerTreasuryShares",
    ],
    BrazilianInsurerFinancialStatementRow: [
      "QuarterlyBrazilianInsurerFinancialStatementRow",
      "YearlyBrazilianInsurerFinancialStatementRow",
    ],
    BrazilianRealEstateFundFinancialStatementRow: [],
    BrazilianRealEstateFundProperty: [
      "BrazilianRealEstateFundPropertyToRent",
      "BrazilianRealEstateFundPropertyToRentUnderConstruction",
      "BrazilianRealEstateFundPropertyToSale",
      "BrazilianRealEstateFundPropertyToSaleUnderConstruction",
    ],
    BrazilianRealEstateFundRealProperty: [
      "BrazilianRealEstateFundLand",
      "BrazilianRealEstateFundPropertyToRent",
      "BrazilianRealEstateFundPropertyToRentUnderConstruction",
      "BrazilianRealEstateFundPropertyToSale",
      "BrazilianRealEstateFundPropertyToSaleUnderConstruction",
    ],
    CalendarEvent: ["BrazilianCompanyFinancialsReleaseCalendarEvent"],
    Comment: ["AssetDiscussionComment", "AssetDiscussionCommentReply"],
    EditableComment: ["AssetDiscussionComment", "AssetDiscussionCommentReply"],
    EditablePost: ["IrpfPost", "PostReply"],
    EventsCalendarEvent: ["BrazilianCompanyFinancialsReleaseCalendarEvent"],
    FinancialSegment: ["FinancialBusinessSegment", "FinancialGeographicSegment"],
    FinancialSegmentIndicator: ["FinancialSegmentFinancialValueIndicator", "FinancialSegmentRatioIndicator"],
    Issuer: [
      "AmericanCompanyIssuer",
      "BrazilianCompanyIssuer",
      "BrazilianRealEstateFund",
      "BrazilianRealEstateFundIssuer",
    ],
    IssuerLogos: ["AmericanCompanyIssuer", "BrazilianCompanyIssuer", "BrazilianRealEstateFundIssuer"],
    Liquidity: ["AmericanCompanyLiquidity", "BrazilianCompanyLiquidity", "BrazilianRealEstateFundLiquidity"],
    LockableComment: ["AssetDiscussionComment"],
    LockablePost: ["IrpfPost"],
    PinnableComment: ["AssetDiscussionComment"],
    PinnablePost: ["IrpfPost", "PostReply"],
    PortfolioAsset: [
      "AmericanCompanyPortfolioAsset",
      "AmericanReitPortfolioAsset",
      "BrazilianCompanyPortfolioAsset",
      "BrazilianRealEstateFundPortfolioAsset",
    ],
    Post: ["IrpfPost"],
    QuarterlyBrazilianCompanyFinancials: [
      "QuarterlyBrazilianBankFinancialStatementRow",
      "QuarterlyBrazilianCompanyFinancialStatementRow",
      "QuarterlyBrazilianInsurerFinancialStatementRow",
    ],
    RankedIssuer: [
      "AmericanCompanyIssuer",
      "BrazilianCompanyIssuer",
      "BrazilianRealEstateFund",
      "BrazilianRealEstateFundIssuer",
    ],
    Reactable: ["AssetDiscussionComment", "AssetDiscussionCommentReply", "IrpfPost", "PostReply"],
    Security: ["AmericanSecurity", "BrazilianSecurity"],
    SpeculativeContent: [
      "HistoricalFFOVersusQuote",
      "HistoricalNetIncomeVersusQuote",
      "HistoricalQuotes",
      "HistoricalReturn",
      "HistoricalShareholders",
      "HistoricalTradingSessions",
    ],
    StripeCoupon: ["StripeFixedAmountCoupon", "StripePercentCoupon"],
    StripeObject: ["StripeCheckoutSession", "StripeInvoice", "StripePaymentIntent", "StripeSubscription"],
    TotalCompensationByYear: ["AmericanCompanyTotalCompensationByYear", "AmericanREITTotalCompensationByYear"],
    UniformResourceLocatable: ["AssetDiscussionComment", "IrpfPost"],
    YearlyBrazilianCompanyFinancials: [
      "YearlyBrazilianBankFinancialStatementRow",
      "YearlyBrazilianCompanyFinancialStatementRow",
      "YearlyBrazilianInsurerFinancialStatementRow",
    ],
  },
};
export default result;
